import Link from 'next/link'
import { useTranslation } from '@/localization/useTranslation'
import { IGlobalProps, IScene } from '@/types/cinematics'
import { NextImage } from '@/components/NextImage'
import { useBrandAssets } from '@/hooks/cinematics/useBrandAssets'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faFacebook } from '@fortawesome/free-brands-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faXTwitter } from '@fortawesome/free-brands-svg-icons'
import { faTiktok } from '@fortawesome/free-brands-svg-icons'
import { faYoutube } from '@fortawesome/free-brands-svg-icons'

import classes from './styles.module.scss'

const socialNetworkIcons = {
  facebook: faFacebook,
  instagram: faInstagram,
  twitter: faTwitter,
  xTwitter: faXTwitter,
  tiktok: faTiktok,
  youtube: faYoutube,
}

interface IFooterProps {
  setFooterProps: IScene['set']['footer']
  globalFooterProps: IGlobalProps['footer']
  globalStoresProps: IGlobalProps['stores']
}

const LOGO_DIMENSIONS = {
  width: 110,
  height: 80,
}

export const Footer = (props: IFooterProps) => {
  const { setFooterProps, globalFooterProps, globalStoresProps } = props
  const { logo } = useBrandAssets()
  const { t } = useTranslation()
  const footer = globalFooterProps || {}
  const hasFooter = setFooterProps?.hasFooter ?? true

  if (!hasFooter) return null

  return (
    <footer className={classes.footer}>
      <div className={classes.content}>
        <div className={classes.logo}>
          <NextImage
            src={logo}
            alt='logo'
            width={LOGO_DIMENSIONS.width}
            height={LOGO_DIMENSIONS.height}
          />
        </div>
        <div className={classes.social}>
          {footer?.social?.map((socialNetwork, index) => {
            return (
              <span key={index} className={classes.app}>
                <Link href={socialNetwork.url} target='_blank'>
                  <FontAwesomeIcon
                    icon={socialNetworkIcons[socialNetwork.icon as keyof typeof socialNetworkIcons]}
                    size='lg'
                  />
                </Link>
              </span>
            )
          })}
        </div>
        <div className={classes['link-container']}>
          <div className={classes.links}>
            {footer?.links?.map((link, index) => {
              return (
                <div key={index} className={classes.link}>
                  <Link href={t(link.url)} target='_blank'>
                    {t(link.text)}
                  </Link>
                </div>
              )
            })}
          </div>
          <div className={classes.stores}>
            {globalStoresProps?.map?.((store, index) => {
              return (
                <div key={index} className={classes.store}>
                  <Link href={store.url} target='_blank'>
                    <NextImage
                      src={globalStoresProps?.find(s => s.key === store.key)?.image || ''}
                      alt={store.key}
                      width={140}
                      height={40}
                    />
                  </Link>
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <div className={classes.bottom}>
        {t(footer?.copyright?.text, { year: new Date().getFullYear() })}
      </div>
    </footer>
  )
}